import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './use-api-client.js';

export function useServerCosts(serverId: string, since: Date, until: Date, options: { enabled?: boolean; staleTime?: number } = {}) {
  const api = useApiClient();

  return useQuery({
    queryKey: ['costs', serverId, since.toISOString(), until.toISOString()],
    queryFn: () => api.costs.byServer(serverId, since.toISOString(), until.toISOString()),
    enabled: !!serverId && options.enabled !== false,
    ...(options.staleTime !== undefined ? { staleTime: options.staleTime } : {}),
  });
}

export function useAggregatedCosts(since: Date, until: Date) {
  const api = useApiClient();

  return useQuery({
    queryKey: ['costs', 'aggregated', since.toISOString(), until.toISOString()],
    queryFn: () => api.costs.aggregated(since.toISOString(), until.toISOString()),
  });
}
